import { Get, Post, Put, Delete } from '../request'

export const login = (authData) => {
  return Post('/auth/login', authData)
}

export const signup = (authData) => {
  return Post('/customers', authData)
}

export const refreshToken = (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }
  return Post('/auth/refresh', null, config)
}

export const fetchMe = (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }
  return Post('/auth/me', null, config)
}

export const logout = (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }
  return Post('/auth/logout', null, config)
}

export const requestPasswordReset = (email) => {
  const params = { email }
  return Post('/customers/password', params)
}

export const resetPasswordByToken = (token, password) => {
  const params = {
    token,
    password,
  }
  return Put('/customers/password', params)
}

export const verifyPasswordReset = (token, password) => {
  const params = {
    remember_token: token,
    password,
  }
  return Put('/verify/password', params)
}

export const verifyEmail = (token) => {
  const params = { token }
  return Put('/customers/email', params)
}

export const verifyEmailByToken = (token) => {
  const params = {
    remember_token: token,
  }
  return Put('/verify/email', params)
}

export const verifyGroup = (token) => {
  const params = { token }
  return Put('/customers/group', params)
}

export const verifyGroupByToken = (token) => {
  const params = {
    remember_token: token,
  }
  return Put('/verify/group', params)
}

export const updateCustomer = ({ id, params, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Put(`/customers/${id}`, params, config)
}

export const updateCustomerEmail = ({ customerId, email, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  const params = {
    customer_id: customerId,
    email,
  }
  return Post('/customers/email', params, config)
}

export const deleteCustomer = ({ id, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Delete(`/customers/${id}`, config)
}

export const registerMember = ({ authData, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Post('/customers/group', authData, config)
}

export const removeMember = ({ id, accessToken }) => {
  const params = {
    customer_group_id: 0,
  }
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Put(`/customers/${id}`, params, config)
}

export const fetchAddressLists = ({ customerId, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }
  return Get(`/customers/${customerId}/addresslists`, config)
}
